import React from 'react';

/** ⓘ de méthode : chaque chiffre dit d'où il vient (réponse UX à « comment être sûr de la
 *  bonne data ? » — Kevin). Le texte vient du dictionnaire hook-brain. */
const MethodHint: React.FC<{ text: string }> = ({ text }) => (
  <span tabIndex={0} title={text} aria-label={text}
    className="inline-grid place-items-center w-[14px] h-[14px] rounded-full border border-line-2 text-faint text-[9px] font-mono cursor-help ml-1 align-middle select-none">i</span>
);
export default MethodHint;
